module.exports = __webpack_public_path__ + "img/差劲.54801796.gif";